import { render, staticRenderFns } from "./d_vipPE.vue?vue&type=template&id=68b891c4&scoped=true&"
import script from "./d_vipPE.vue?vue&type=script&lang=js&"
export * from "./d_vipPE.vue?vue&type=script&lang=js&"
import style0 from "./d_vipPE.vue?vue&type=style&index=0&id=68b891c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b891c4",
  null
  
)

export default component.exports